import { useState, useEffect } from 'react';
import { DEVICE_PLATFORM } from '../constants/device';
import type { ValueOf } from '@autopass-web/types';

const useDeviceType = () => {
  const [device, setDevice] = useState<ValueOf<typeof DEVICE_PLATFORM>>(
    DEVICE_PLATFORM.DESKTOP,
  );

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1024 && device !== DEVICE_PLATFORM.DESKTOP) {
        setDevice(DEVICE_PLATFORM.DESKTOP);
      } else if (
        window.innerWidth <= 1024 &&
        window.innerWidth > 768 &&
        device !== DEVICE_PLATFORM.PAD
      ) {
        setDevice(DEVICE_PLATFORM.PAD);
      } else if (
        window.innerWidth <= 768 &&
        device !== DEVICE_PLATFORM.MOBILE
      ) {
        setDevice(DEVICE_PLATFORM.MOBILE);
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [device]);

  return device;
};

export default useDeviceType;
